import { WhatsNewState } from './reducers';

/* eslint-disable import/prefer-default-export */
export const whatsNewStateSelector = (state: any) =>
  state.whatsNew as WhatsNewState;
